import { render, staticRenderFns } from "./relevantRecommend.vue?vue&type=template&id=75e6d7ea&scoped=true&"
import script from "./relevantRecommend.vue?vue&type=script&lang=js&"
export * from "./relevantRecommend.vue?vue&type=script&lang=js&"
import style0 from "./relevantRecommend.vue?vue&type=style&index=0&id=75e6d7ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e6d7ea",
  null
  
)

export default component.exports